import {store} from "../../../store/store";
import Select from '../../../components/select.vue'
import {getHallCode} from "../../../common/config";
export default {
  name:'searchinfor',
  data(){
    return{
      fromSearch:0,//0表示首页高级搜索。1就是具体的高级搜索页面
      select: {desc: '全部',value:''},
      list: [{desc: '全部',value:''},{desc: '平台资讯',value:1}, {desc: ' 客户资讯',value:2}, {desc: '图书馆资讯',value:2}],
      industry: {desc: '全部',value:''},
      industryList:[{desc: '全部',value:''},{desc: '文化类',value:1},{desc: '教育类',value:2}],
      libCode:'',
      hallCode:"", //图书馆网站
      pageCount:3,
      pageNo:1,
      source:'',//来源
      title:'',//标题
    }
  },
  components:{
    Select,
  },
  beforeMount() {
    this.fromSearch = this.$route.query.fromSearch;
    this.libCode = this.$route.query.libCode;
    this.hallCode = this.$route.query.hallCode;
    if(store.webType == 1) {
      this.list = [{desc: '全部',value:''}, {desc: ' 客户资讯',value:2}, {desc: '图书馆资讯',value:2}]
    }
  },
  methods: {
    search() {
      var pathStr='/indexsearch';
      if(this.fromSearch!=1){
        pathStr="/indexsearch";
      }
      this.$router.push({path:pathStr ,
        query: {
          category: this.select.value,
          industry: this.industry.value,
          categoryDesc:this.select.desc,
          industryDesc:this.industry.desc,
          libCode: this.libCode,
          pageCount: this.pageCount,
          pageNo: this.pageNo,
          source:this.source,
          title:this.title,
          type:5,
          fromSearch:this.fromSearch,
          hallCode: this.hallCode
        }});
    },
  }
}
